let _ = require('lodash');
let numberOfEmployees = require('./number-of-employees');
let paymentTypes = require('./payment-types');
let legalEntities = require('./legalEntities');
let purposes = require('./purposes');

function calcEnabledGreederColumns (args, state) {
    let sources = state.get(['order', 'addParams', 'greederColumns', 'source']);
    let enabledSources = _.filter(Object.keys(sources), (x) => sources[x].isChecked === true);
    let isEnabledFunc = (x) => false;
    if (enabledSources.length === 2) {
        isEnabledFunc = (x) => true;
    } else if (enabledSources[0] === 'egrip') {
        isEnabledFunc = (x) => x.isEgrip === true;
    } else if (enabledSources[0] === 'egrul') {
        isEnabledFunc = (x) => x.isEgrul === true;
    }
    let columns = _.filter(state.get(['order', 'originalParameters', 'greederColumns']), (x) => x.isEgrip || x.isEgrul);
    let viewColumns = state.get(['order', 'addParams', 'greederColumns', 'view', 'gosReg']);
    _.forEach(columns, function (x) {
        let index = _.findIndex(viewColumns, { id: x.id });
        state.set(['order', 'addParams', 'greederColumns', 'view', 'gosReg', index, 'isEnabled'], isEnabledFunc(x));
    });
}

module.exports = {
    changeDateDatepickerFrom ({ date }, state) {
        state.set(['order', 'addParams', 'datepicker', 'value'], date);
        let to = state.get(['order', 'addParams', 'datepicker2', 'value']);
        if (to && date > to) {
            state.unset(['order', 'addParams', 'datepicker2', 'value']);
        }
    },

    changeDateDatepickerTo ({ date }, state) {
        // добавляем чуть меньше суток, чтобы получить время 23:59:59
        let dateEnd = Number(date) + 86340;
        state.set(['order', 'addParams', 'datepicker2', 'value'], dateEnd);
        let from = state.get(['order', 'addParams', 'datepicker', 'value']);
        if (from && dateEnd < from) {
            state.unset(['order', 'addParams', 'datepicker', 'value']);
        }
    },

    initExportColumnsState (args, state) {
        let columns = {};
        _.forEach(state.get(['order', 'originalParameters', 'exportColumns', 'columns']), function (x) {
            columns[x.id] = { id: x.id, isChecked: x.isBasic, isMustBeFilled: false };
        });
        state.set(['order', 'addParams', 'exportColumns'], columns);
    },

    initGreederColumns (args, state) {
        let origin = state.get(['order', 'originalParameters', 'greederColumns']);

        let columnGroups = _.groupBy(_.filter(origin, (x) => x.source), (x) => x.source);
        _.forEach(columnGroups, function (x, key) {
            state.set(['order', 'addParams', 'greederColumns', 'view', key],
                _.map(x, (y) => ({ id: y.id, title: y.title })));
        });
        state.set(['order', 'addParams', 'greederColumns', 'view', 'gosReg'],
            _.map(_.filter(origin, (x) => x.isEgrip || x.isEgrul), (x) => ({ id: x.id, title: x.title })));

        let values = {};
        _.forEach(origin, (x) => {
            values[x.id] = { id: x.id };
        });
        state.set(['order', 'addParams', 'greederColumns', 'value'], values);
    },

    setGreederColumnIsChecked ({ path, value }, state) {
        state.set(['order', 'addParams', 'greederColumns', 'value', path, 'isChecked'], value);
    },

    setAllGreederColumnIsChecked ({ value }, state) {
        let gosColumns = state.get(['order', 'addParams', 'greederColumns', 'view', 'gosReg']);
        if (value === true) {
            gosColumns = _.filter(gosColumns, { isEnabled: true });
        }
        _.forEach(gosColumns, (x) => {
            state.set(['order', 'addParams', 'greederColumns', 'value', x.id, 'isChecked'], value);
        });
        calcEnabledGreederColumns({}, state);
    },

    setGreederColumnSource ({ path, value }, state) {
        state.set(['order', 'addParams', 'greederColumns', 'source', path, 'isChecked'], value);
        calcEnabledGreederColumns({}, state);
    },

    calcEnabledGreederColumns,

    setExportColumnIsChecked ({ path, value }, state) {
        let pathInt = parseInt(path, 10);
        state.set(['order', 'addParams', 'exportColumns', pathInt, 'isChecked'], value);
        if (value === false) {
            state.set(['order', 'addParams', 'exportColumns', pathInt, 'isMustBeFilled'], value);
            state.unset(['order', 'addParams', 'exportColumns', pathInt, 'value']);
            state.unset(['order', 'addParams', 'exportColumns', pathInt, 'error']);

            // если колонка с фильтром типа IsInRangeDatetime, то очищаем DatePicker
            let dateColumnId = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']),
                { filterType: 'IsInRangeDatetime' });
            if (dateColumnId && pathInt == dateColumnId.id) {
                state.set(['order', 'addParams', 'datepicker', 'value'], null);
                state.set(['order', 'addParams', 'datepicker2', 'value'], null);
            }

            // если убрали галку со столбца, то очищаем соответствующее дерево
            legalEntities.tryUnsetSelected({ path: pathInt }, state);
            numberOfEmployees.tryUnsetSelected({ path: pathInt }, state);
            paymentTypes.tryUnsetSelected({ path: pathInt }, state);
            purposes.tryUnsetSelected({ path: pathInt }, state);
        }
    },

    setExportDateTimeColumnIsChecked (args, state) {
        let dateColumnId = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']),
            { filterType: 'IsInRangeDatetime' }).id;
        state.set(['order', 'addParams', 'exportColumns', dateColumnId, 'isChecked'], true);
    },

    setExportAreaColumnIsChecked (args, state) {
        let columnId = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']),
            { filterType: 'IsInRangeDouble' }).id;
        state.set(['order', 'addParams', 'exportColumns', columnId, 'isChecked'], true);
    },

    setExportColumnIsMustBeFilled ({ path, value }, state) {
        state.set(['order', 'addParams', 'exportColumns', path, 'isMustBeFilled'], value);
        if (value) {
            state.set(['order', 'addParams', 'exportColumns', path, 'isChecked'], value);
        }
    },
    // Отчекиваем дополнительные параметры для PropertyName
    unsetRelatedParams ({ path, value }, state) {
        const RELATED = {
            Inn: ['order', 'addParams', 'includeArchiveInn']
        };

        const columns = state.get(['order', 'originalParameters', 'exportColumns', 'columns']);
        const propertyName = (_.find(columns, ({ id }) => id == path) || {}).propertyName;

        if (value === false && propertyName && RELATED[propertyName]) {
            state.set(RELATED[propertyName], false);
        }
    }
};



// WEBPACK FOOTER //
// ./actions/custom-order/additional-parameters.js